// =============================================================================
// FILE:
// frontend/src/modules/pms/task_execution/components/TaskExecutionHeader.js
// =============================================================================

import React from "react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TaskExecutionHeader() {

  return (

    <div style={styles.container}>


      <div>

        <div style={styles.title}>

          Execution Workbench

        </div>


        <div style={styles.subtitle}>


          Operational execution monitoring,
          readiness visibility,
          request workflow,
          and task execution management

        </div>

      </div>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  container: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 20,

    marginBottom: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  title: {

    fontSize: 28,

    fontWeight: 700,

    color: "#111827"
  },

  subtitle: {

    marginTop: 8,

    fontSize: 14,

    color: "#6b7280"
  }
};